import { useSelector } from 'react-redux';
import useIsMobile from './useIsMobile';

/**
 * Видна ли шторка меню прямо сейчас.
 *
 * Флаг в состоянии один на оба размера экрана, но значит в них разное: на широком
 * экране боковая панель показана по умолчанию и кнопка её сворачивает, на узком меню
 * по умолчанию скрыто и кнопка его открывает. Отсюда инверсия — и держать её надо в
 * одном месте. Раньше её знал только `Layout`, а `Topbar` объявлял читалке сам флаг:
 * на телефоне кнопка говорила «развёрнуто», когда меню было закрыто, и наоборот.
 */
const useDrawerVisible = () => {
    const isOpen = useSelector((state) => state.drawer.isOpen);
    const isMobile = useIsMobile();

    return isMobile ? !isOpen : isOpen;
};

export default useDrawerVisible;
